export const normalizeStringValue = <T>(value?: T): string => {
  return value ? String(value) : '';
};
